// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router';
import HomeIndex from '@/pages/home/index.vue'

const routes = [
    {
        path: '/',
        name: '_home',
        redirect: '/home',
        component: HomeIndex,
        children: [
            {
                path: '/home',
                name: 'home',
                meta: {
                    title: '全国公共资源交易平台数据服务'
                },
                component: () => import('@/pages/home/content.vue')
            },
            /* {
                path: '/jghome',
                name: 'jghome',
                meta: {
                    title: '全国公共资源交易平台数据服务'
                },
                component: () => import('@/pages/jghome/jgcontent.vue')
            } */
        ]
    },
    {
        path: '/',
        name: 'company',
        redirect: '/company',
        component: HomeIndex,
        children: [
            {
                path: '/company',
                name: 'company-detail',
                meta: {
                    title: '主体详情'
                },
                component: () => import('@/pages/company/company.vue')
            }, 
            {
                path: '/table',
                name: 'table',
                meta: {
                    title: '履约信息'
                },
                component: () => import('@/pages/company/table.vue')
            }
        ]
    },
    // {
    //     path: '/',
    //     name: 'jgcompany',
    //     redirect: '/jgcompany',
    //     component: HomeIndex,
    //     children: [
    //         {
    //             path: '/jgcompany',
    //             name: 'jgcompany',
    //             meta: {
    //                 title: '主体详情'
    //             },
    //             component: () => import('@/pages/jgcompany/jgcompany.vue')
    //         }
    //     ]
    // },
    {
        path: '/',
        name: 'apiInfo',
        redirect: '/apiInfo',
        component: HomeIndex,
        children: [
            {
                path: '/apiInfo',
                name: 'apiInfo-page',
                meta: {
                    title: '接口服务'
                },
                component: () => import('@/pages/apiInfo/apiInfo.vue')
            }
        ]
    },
    {
        path: '/',
        name: 'search',
        redirect: '/search',
        component: HomeIndex,
        children: [
            {
                path: '/search',
                name: 'search-page',
                meta: {
                    title: '主体成交查询'
                },
                component: () => import('@/pages/search/searchList.vue')
            }
        ]
    },
    // {
    //     path: '/',
    //     name: 'jgsearch',
    //     redirect: '/jgsearch',
    //     component: HomeIndex,
    //     children: [
    //         {
    //             path: '/jgsearch',
    //             name: 'jgsearch',
    //             meta: {
    //                 title: '机构成交查询'
    //             },
    //             component: () => import('@/pages/search/jgsearchList.vue')
    //         }
    //     ]
    // },
    {
        path: '/',
        name: 'info',
        redirect: '/info',
        component: HomeIndex,
        children: [
            {
                path: '/info',
                name: 'info-page',
                meta: {
                    title: '网站声明'
                },
                component: () => import('@/pages/detail/info.vue')
            }
        ]
    },
    {
        path: '/',
        name: 'project',
        redirect: '/project',
        component: HomeIndex,
        children: [
            {
                path: '/project',
                name: 'project-detail',
                meta: {
                    title: '公告详情'
                },
                component: () => import('@/pages/detail/project.vue')
            }
        ]
    },
    // {
    //     path: '/',
    //     name: 'jgproject',
    //     redirect: '/jgproject',
    //     component: HomeIndex,
    //     children: [
    //         {
    //             path: '/jgproject',
    //             name: 'jgproject',
    //             meta: {
    //                 title: '公告详情'
    //             },
    //             component: () => import('@/pages/detail/jgproject.vue')
    //         }
    //     ]
    // },
    {
        path: '/',
        name: 'credit',
        redirect: '/credit',
        component: HomeIndex,
        children: [
            {
                path: '/credit',
                name: 'credit-page',
                meta: {
                    title: '信用信息'
                },
                component: () => import('@/pages/detail/credit.vue')
            }
        ]
    },
    // {
    //     path: '/',
    //     name: 'jgcredit',
    //     redirect: '/jgcredit',
    //     component: HomeIndex,
    //     children: [
    //         {
    //             path: '/jgcredit',
    //             name: 'jgcredit-page',
    //             meta: {
    //                 title: '信用信息'
    //             },
    //             component: () => import('@/pages/detail/jgcredit.vue')
    //         }
    //     ]
    // },
    {
        path: '/',
        name: 'aptitude',
        redirect: '/aptitude',
        component: HomeIndex,
        children: [
            {
                path: '/aptitude',
                name: 'aptitude-page',
                meta: {
                    title: '资格资质'
                },
                component: () => import('@/pages/detail/aptitude.vue')
            }
        ]
    },
    {
        path: '/',
        name: 'rank',
        redirect: '/rank',
        component: HomeIndex,
        children: [
            {
                path: '/rank',
                name: 'rank-page',
                meta: {
                    title: '交易龙虎榜'
                },
                component: () => import('@/pages/rank/rank.vue')
            }
        ]
    },
    // {
    //     path: '/',
    //     name: 'jgrank',
    //     redirect: '/jgrank',
    //     component: HomeIndex,
    //     children: [
    //         {
    //             path: '/jgrank',
    //             name: 'jgrank',
    //             meta: {
    //                 title: '交易龙虎榜'
    //             },
    //             component: () => import('@/pages/rank/jgrank.vue')
    //         }
    //     ]
    // },
    // {
    //     path: '/',
    //     name: 'rank-new',
    //     redirect: '/rank-new',
    //     component: HomeIndex,
    //     children: [
    //         {
    //             path: '/rank-new',
    //             name: 'rank-new',
    //             meta: {
    //                 title: '交易龙虎榜'
    //             },
    //             component: () => import('@/pages/rank/rank-new.vue')
    //         }
    //     ]
    // }
];
const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
});

export default router;
